<div class="card">
  <div class="card-body text-center">
    <h5 class="card-title d-flex align-items-center justify-content-center">
      {{ phase }} {{ label }}
      <button
        (click)="handleDeleteMedia($event)"
        class="delete-media"
        *ngIf="mediaSrc"
        title="Delete {{ phase }} {{ label }}"
      >
        <ion-icon
          name="trash-outline"
          class="text-danger"
          style="pointer-events: none"
          *ngIf="!isDeleting"
        ></ion-icon>
        <div
          class="spinner-border spinner-border-sm"
          role="status"
          style="border-width: 0.1em; margin-bottom: 3px"
          *ngIf="isDeleting"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </button>
    </h5>
    <ng-container *ngIf="mediaSrc; else addButton">
      <ng-container [ngSwitch]="label">
        <audio *ngSwitchCase="'Audio'" controls class="w-100">
          <source [src]="mediaSrc" type="audio/webm" />
          Your browser does not support the audio element.
        </audio>
        <video *ngSwitchCase="'Video'" controls class="w-100">
          <source [src]="mediaSrc" type="video/webm" />
          Your browser does not support the video element.
        </video>
      </ng-container>
    </ng-container>
    <ng-template #addButton>
      <button class="btn btn-secondary w-100 mb-3" (click)="openHandler($event, type, phase)">
        Add {{ label }}
      </button>
    </ng-template>
  </div>
</div>
